import React from 'react'
import PropTypes from 'prop-types'
import Module from '#components/m/Wissensportal/Module'

export function Modules({modules, modifier}) {
  return (
    <div className={`modules__wrapper ${modifier}`}>
      {modules && modules.map(module => <Module {...module} key={module.id} />)}
    </div>
  )
}

Modules.propTypes = {
  modules: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      status: PropTypes.string,
    }),
  ),
  modifier: PropTypes.string,
}
